/**
 * How the line table shows a quantity override: `separate` puts the engine's
 * Calc beside the buyer's Qty, `simple` shows only Qty (marked when it was
 * overridden) with Calc on hover.
 */
export type OverrideDisplay = 'separate' | 'simple';

export const DEFAULT_OVERRIDE_DISPLAY: OverrideDisplay = 'separate';

export function parseOverrideDisplay(raw: string | null): OverrideDisplay {
  return raw === 'simple' || raw === 'separate'
    ? raw
    : DEFAULT_OVERRIDE_DISPLAY;
}
